module.exports = __webpack_public_path__ + "img/img_record_tips_modal.4220f65c.png";